import React, { useState, useEffect } from "react";
import {
  ChangePRoductsCategoryAPI,
  getSupermarketCategoryApi,
  getSupermarketProductListApi,
} from "../../../Api/PanelAdminServices";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import EditProductCategoryTabel from "../../Tables/Category/EditProductCategoryTabel/EditProductCategoryTabel";
import Style from "./EditProductsCategoryContainer.module.scss";
import { Modal } from "react-bootstrap";
import Button from "../../Button/Button";
import Select from "react-select";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";

const EditProductsCategoryContainer = () => {
  const [ProductsState, setProductsState] = useState(null);
  const [rawInfo, setRawInfo] = useState([]);
  const [showEditModalState, setShowEditModalState] = useState(false);
  const [disable, setDisable] = useState(false);
  const [SupperMarketCategoryState, setSupperMarketCategoryState] =
    useState(null);
  const [selectedCategoryState, setSelectCategooryState] = useState(null);

  useEffect(() => {
    getMarketCategory();
  }, []);

  const getMarketCategory = async () => {
    getSupermarketProductListApi((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setProductsState(res.products);
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });

    getSupermarketCategoryApi((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          let categoryLevelTwo = [];
          res.category.forEach((element) => {
            if (element.parent !== "2") {
              categoryLevelTwo.push(element);
            }
          });
          setSupperMarketCategoryState(categoryLevelTwo);
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
  };

  const showModal = (selectedRow, info) => {
    if (selectedRow.length === 0) {
      errorToast("ابتدا یک محصول کلیک کنید");
    } else {
      let idProducts = [];
      selectedRow.forEach((element) => {
        idProducts.push(element.productId);
      });
      setRawInfo(idProducts);
      setShowEditModalState(true);
    }
  };
  const HideModlaHandler = () => {
    setShowEditModalState(false);
  };
  const CategoryChangeHandler = (value) => {
    setSelectCategooryState(value.value);
  };
  const EditeCategoryProductHandler = () => {
    setDisable(true);
    if (selectedCategoryState === null) {
      errorToast("دسته بندی انتخاب نشده!");
      setDisable(false);
    } else {
      let info = {
        products: rawInfo,
        category_id: parseInt(selectedCategoryState),
      };
      ChangePRoductsCategoryAPI(info, (succ) => {
        if (succ.status === 1) {
          succToast(succ.message);
          getMarketCategory();
          setDisable(false);
        } else {
          errorToast(succ.message);
          setDisable(false);
        }
      });
    }
  };
  const colourStyles = {
    control: (styles) => ({ ...styles, width: "280px" }),
  };

  return (
    <div className={Style.componentHolder}>
      <Modal
        show={showEditModalState}
        onHide={HideModlaHandler}
        className={Style.modalEdit}
      >
        <Modal.Header>
          <Modal.Title
            style={{ fontSize: "1rem", width: "100%", direction: "rtl" }}
          >
            ویرایش دسته بندی
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Select
              options={
                SupperMarketCategoryState &&
                SupperMarketCategoryState.map((item) => {
                  return {
                    value: item.id,
                    label: item.category,
                  };
                })
              }
              styles={colourStyles}
              placeholder={"دسته بندی"}
              onChange={CategoryChangeHandler}
              isLoading={SupperMarketCategoryState === undefined}
            />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-around",
                margin: "1rem 0",
              }}
            >
              <Button
                ClassBtn={"rejectBtn"}
                Value={"لغو"}
                ClickHandler={HideModlaHandler}
              />
              <Button
                ClassBtn={"confirmBtn"}
                Value={"ثبت"}
                ClickHandler={EditeCategoryProductHandler}
                disabledProps={disable}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <TableFixedPage title={"ویرایش دسته بندی محصولات"} />
      <EditProductCategoryTabel data={ProductsState} showModal={showModal} />
    </div>
  );
};

export default EditProductsCategoryContainer;
